import { Box, Divider, Menu, MenuItem, SxProps, Theme, useTheme } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import authStore, { logout } from "stores/authStore";

const getStyles = (theme: Theme): { [key: string]: SxProps } => ({
  userInfo: {
    p: 1.5,
    mt: "-8px",
    mb: "8px",
    textAlign: "center",
    color: theme.palette.primary.dark,
    backgroundColor: theme.palette.grey[100],
  },
  userName: {
    fontWeight: "bold",
    fontSize: "16px",
  },
  userEmail: {
    fontSize: "13px",
    color: theme.palette.text.secondary,
  },
  menu: {
    color: theme.palette.primary.dark,
  },
});

type UserMenuProps = {
  anchor: HTMLElement | null;
  handleClose: () => void;
};

export default function UserMenu({ anchor, handleClose }: UserMenuProps) {
  const styles = getStyles(useTheme());
  const firstName = authStore.useState((s) => s.firstName);
  const lastName = authStore.useState((s) => s.lastName);
  const email = authStore.useState((s) => s.email);

  return (
    <Menu
      anchorEl={anchor}
      id="account-menu"
      open={!!anchor}
      onClose={handleClose}
      onClick={handleClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <Box sx={styles.userInfo}>
        <Box sx={styles.userName}>
          {firstName} {lastName}
        </Box>
        <Box sx={styles.userEmail}>{email}</Box>
      </Box>
      <Divider />
      <MenuItem dense sx={styles.menu} onClick={logout}>
        <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
        Logout
      </MenuItem>
    </Menu>
  );
}
